import { computed, type ComputedRef } from 'vue';
import { flagsRevision, isFeatureEnabled } from '@/helpers/unleash';

const flags = new Map<string, ComputedRef<boolean>>();

// Drop-in for `useFlag` from `@unleash/proxy-client-vue`, which adds two client listeners per call and freezes the page when a big order unmounts thousands of them.
// Every caller of a flag shares one computed, so mounting and unmounting cost nothing.
export function useFlag(name: string): ComputedRef<boolean> {
  let flag = flags.get(name);
  if (!flag) {
    flag = computed(() => {
      void flagsRevision.value;
      return isFeatureEnabled(name);
    });
    flags.set(name, flag);
  }
  return flag;
}
